export const handleDownload = () => {
  window.open("https://apps.apple.com/app/id6479000097", "_blank");
};
